document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".item_credit").forEach(function (item) {
    const creditButton = item.querySelector(".credit_button");

    creditButton.addEventListener("click", function () {
      item.classList.toggle("open");
    });
  });
});